var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73498 11.5017L8.17958 9.24748C8.27318 8.78728 8.14838 8.31148 7.85198 7.95268C7.55558 7.59388 7.11878 7.38328 6.65078 7.38328H2.36078V6.54088L4.36538 1.92328H10.6756C10.816 1.92328 10.9408 2.04808 10.9408 2.18848V8.30368L7.73498 11.5017ZM7.04078 14.4033L12.0406 9.40348C12.337 9.10708 12.5008 8.70928 12.5008 8.29588V2.18848C12.5008 1.18228 11.6818 0.363281 10.6756 0.363281H4.35758C3.80378 0.363281 3.29678 0.651881 3.01598 1.11988L0.933381 5.91688C0.847581 6.11188 0.800781 6.32248 0.800781 6.54088V7.38328C0.800781 8.24128 1.50278 8.94328 2.36078 8.94328H6.65078L5.93318 12.5703C5.89418 12.7419 5.91758 12.9291 5.99558 13.0851C6.17498 13.4361 6.40118 13.7559 6.68198 14.0367L7.04078 14.4033ZM14.8408 8.94328H16.4008V0.363281H14.8408C14.4118 0.363281 14.0608 0.714281 14.0608 1.14328V8.16328C14.0608 8.59228 14.4118 8.94328 14.8408 8.94328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.1583ce4babebbe2a07c1796d461c6233.svg";
export { ForwardRef as ReactComponent };